"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventListenerCallbackConfig = void 0;
const ImageStudioEventType_1 = require("./ImageStudioEventType");
const SdkEventType_1 = require("./SdkEventType");
exports.eventListenerCallbackConfig = {
    [ImageStudioEventType_1.ImageStudioEventType.Connect]: undefined,
    [ImageStudioEventType_1.ImageStudioEventType.Disconnect]: undefined,
    [ImageStudioEventType_1.ImageStudioEventType.ImageSave]: {
        defaultResponse: SdkEventType_1.SDKEventType.Success,
        validResponses: [SdkEventType_1.SDKEventType.Success, SdkEventType_1.SDKEventType.Fail],
    },
};
//# sourceMappingURL=EventListenerCallback.js.map